import { MailIcon } from '@air/design-icons';

import { LibraryDetailsAccessibility } from '~/components/LibraryBeta/LibrarySettingsModal/components/LibraryDetails/components/LibraryDetailsAccessibility';

export const LibraryDetailsAccessibilityPrivate = () => {
  return (
    <LibraryDetailsAccessibility
      description="An admin must approve a member’s request to join this library"
      label="Request to join"
      icon={<MailIcon size="sm" className="text-gray-10" />}
    />
  );
};
